const devApiUrl = 'http://www.yw.loc';
const proApiUrl = '';

const nodeDevEnv = process.env.NODE_ENV == 'development';

export default {
  nodeDevEnv: nodeDevEnv,
  apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
  siteName: '2345天气王',
  apiPrefix: '',
  timeout: 10000,
  cookiesExpires: 7,
  requestRetry: 4,
  requestRetryDelay: 800,
  tokenKey: 'token',
  userInfoKey: 'USER_INFO',
  xAccessSign: '20190507111430',
  responseTonken: 'auth-authorization',
  loginUrl: '/login'
};
